import { render } from "./drugPrice.vue?vue&type=template&id=2f752dee&scoped=true"
import script from "./drugPrice.vue?vue&type=script&lang=js"
export * from "./drugPrice.vue?vue&type=script&lang=js"

import "./drugPrice.vue?vue&type=style&index=0&id=2f752dee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f752dee"

export default script